export const API_STATUS ={
    initiated:0,
    success:1,
    failed:2,
    error:3,
}